// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"0f91fb0582e43674fa8d","453":"e9b93c308659ecf0034d","454":"d032e6026c349283126f"}[chunkId] + ".js";
};